import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

export const WIPE_IN = 0.45;
const WIPE_OUT = 0.55;
const EASE = [0.76, 0, 0.24, 1];

export default function PageWipe() {
  const { pathname } = useLocation();
  const [phase, setPhase] = useState("idle");
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    setPhase("in");
    const mid = setTimeout(() => {
      window.scrollTo(0, 0);
      setPhase("out");
    }, WIPE_IN * 1000);
    const end = setTimeout(() => setPhase("idle"), (WIPE_IN + WIPE_OUT) * 1000 + 50);
    return () => {
      clearTimeout(mid);
      clearTimeout(end);
    };
  }, [pathname]);

  const active = phase !== "idle";

  return (
    <motion.div
      aria-hidden="true"
      data-testid="page-wipe"
      data-phase={phase}
      className={`pointer-events-none fixed inset-0 z-[90] bg-[#0B0C0E] ${active ? "" : "invisible"}`}
      style={{ transformOrigin: phase === "out" ? "top" : "bottom" }}
      initial={false}
      animate={{ scaleY: phase === "in" ? 1 : 0 }}
      transition={{ duration: phase === "out" ? WIPE_OUT : WIPE_IN, ease: EASE }}
    >
      <div className={`absolute inset-x-0 h-px bg-umber/70 ${phase === "out" ? "bottom-0" : "top-0"}`} />
      <div className="noise absolute inset-0 opacity-40" />
    </motion.div>
  );
}
